export default __webpack_public_path__ + "static/media/padron1.cebc13df.png";